import styled from '@emotion/styled';

import DialogSubmitField from 'presentations/views/components/molecules/DialogSubmitField';
import Dialog from 'presentations/views/components/atoms/Dialog';
import TextField from 'presentations/views/components/atoms/TextField';
import { spacing } from 'presentations/views/styles';
import ErrorText from '../../atoms/ErrorText';
import { ErrorList } from 'domains/models';

interface Props {
  isOpen: boolean;
  title?: string;
  description?: string;
  value?: string | null;
  isLoading?: boolean;
  onClose?: Function;
  onSubmit?: Function;
  onChange?: Function;
  errors?: ErrorList | null;
}

export default function Component(props: Props) {
  return (
    <Dialog
      isOpen={props.isOpen}
      onClose={props.onClose}
      title={props.title}
      actions={
        <DialogSubmitField
          isLoading={props.isLoading}
          onSubmit={props.onSubmit}
          onCancel={props.onClose}
          isDisabled={(props.value || '').length === 0}
        />
      }
    >
      {props.description && <Description>{props.description}</Description>}
      <TextField onChange={props.onChange} value={props.value} isFullWidth />
      {props.errors?.name?.length && (
        <ErrorText>{props.errors.name[0]}</ErrorText>
      )}
    </Dialog>
  );
}

const Description = styled.div`
  margin: ${spacing(24)} 0;
`;
